import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/contexts/CartContext";
import { CookieProvider } from "@/contexts/CookieContext";
import { AuthProvider } from "@/contexts/AuthContext";
import CookieConsent from "@/components/CookieConsent";
import Index from "./pages/Index";
import AboutUs from "./pages/AboutUs";
import CarteDeCart from "./pages/CarteDeCart";
import CopertiPiele from "./pages/CopertiPiele";
import Icoane from "./pages/Icoane";
import ObiecteReligioase from "./pages/ObiecteReligioase";
import ROST from "./pages/ROST";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import TermeniConditii from "./pages/TermeniConditii";
import PoliticaConfidentialitate from "./pages/PoliticaConfidentialitate";
import PoliticaCookies from "./pages/PoliticaCookies";
import NotFound from "./pages/NotFound";
import { AdminLayout } from "./components/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProductForm from "./pages/admin/ProductForm";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <CookieProvider>
        <AuthProvider>
          <CartProvider>
            <Toaster />
            <Sonner />
            <CookieConsent />
            <BrowserRouter>
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<Index />} />
                <Route path="/despre-noi" element={<AboutUs />} />
                <Route path="/carte-de-cult" element={<CarteDeCart />} />
                <Route path="/coperti-piele" element={<CopertiPiele />} />
                <Route path="/icoane" element={<Icoane />} />
                <Route path="/obiecte-religioase" element={<ObiecteReligioase />} />
                <Route path="/rost" element={<ROST />} />
                <Route path="/magazin" element={<Shop />} />
                <Route path="/produs/:slug" element={<ProductDetail />} />
                <Route path="/cos" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/comanda-finalizata" element={<OrderSuccess />} />
                <Route path="/termeni-conditii" element={<TermeniConditii />} />
                <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
                <Route path="/politica-cookies" element={<PoliticaCookies />} />

                {/* Admin routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="products/new" element={<ProductForm />} />
                  <Route path="products/:id/edit" element={<ProductForm />} />
                </Route>

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </CookieProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
